import React from 'react';

interface EmptyStateProps {
  title?: string;
  message?: string;
  action?: React.ReactNode;
}

export function EmptyState({
  title = 'No results found',
  message = 'There are no items to display.',
  action,
}: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        gap: '12px',
        textAlign: 'center',
        color: '#666',
      }}
    >
      <div style={{ fontSize: '3rem', lineHeight: 1 }}>&#128269;</div>
      <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#444' }}>{title}</h3>
      <p style={{ margin: 0, fontSize: '0.9rem' }}>{message}</p>
      {action && <div style={{ marginTop: '8px' }}>{action}</div>}
    </div>
  );
}
